import React from 'react'
import FlashSmartWatchProduct from './FlashSmartWatchProduct'
import FestivalSale from './FestivalSale'


const ContentDealSmartWatch = () => {
  return (
    <section className='bg-content'>

        

        <div className="smartWatch-container">
            <FlashSmartWatchProduct />
            <FestivalSale />
        </div>

    </section>
  )
}

export default ContentDealSmartWatch
